module.exports = __webpack_public_path__ + "img/phones-sm.a32f4ab2.png";